module.exports = __webpack_public_path__ + "img/download.343c9d8f.png";